// src/pages/seller/SellerPage.tsx
import React, { useState } from 'react';
import NoticeComponent from '../../components/NoticeComponent';
import { HiWallet } from 'react-icons/hi2';
import { IoLockOpen } from 'react-icons/io5';
import { BiSolidPencil } from 'react-icons/bi';
import { FaBoxArchive, FaPlus } from 'react-icons/fa6';
import { v4 as uuidv4 } from 'uuid';

import Modal from '../../components/Modal';
import AddProduct from './AddProduct';
import StatusPage from './productStatus/StatusPage';

// Product 타입 정의 (id 포함)
interface Product {
  id: string;
  image: string | null;
  category: string;
  name: string;
  price: number;
  status: string;
}

// NewProduct 타입 정의 (id 제외)
interface NewProduct {
  image: string | null;
  category: string;
  name: string;
  price: number;
  status: string;
}

export default function SellerPage() {
  const statuses = [
    { name: '전체', icon: <HiWallet /> },
    { name: '심사중', icon: <BiSolidPencil /> },
    { name: '공개', icon: <IoLockOpen /> },
    { name: '아카이브', icon: <FaBoxArchive /> },
  ];

  const categories = [
    { name: '전체' },
    { name: '아이템' },
  ];

  const [selectedStatus, setSelectedStatus] = useState('전체');
  const [selectedCategory, setSelectedCategory] = useState('전체');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const initialProducts: Product[] = [
    {
      id: uuidv4(),
      image: null,
      category: '아이템',
      name: '예시 상품 1',
      price: 10000,
      status: '공개',
    },
    {
      id: uuidv4(),
      image: null,
      category: '아이템',
      name: '예시 상품 2',
      price: 20000,
      status: '심사중',
    },
    {
      id: uuidv4(),
      image: null,
      category: '아이템',
      name: '예시 상품 3',
      price: 15000,
      status: '아카이브',
    },
  ];
  // 상품 리스트를 상태로 관리
  const [products, setProducts] = useState<Product[]>(initialProducts);


  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // 상품 추가 함수
  const handleAddProduct = (newProduct: NewProduct) => {
    const productWithId: Product = { ...newProduct, id: uuidv4() };
    setProducts((prevProducts) => [...prevProducts, productWithId]);
    closeModal(); // 모달 닫기
  };

  // 카테고리 필터링 추가
  const filteredProducts = products.filter((product) => {
    const statusMatch = selectedStatus === '전체' || product.status === selectedStatus;
    const categoryMatch = selectedCategory === '전체' || product.category === selectedCategory;
    return statusMatch && categoryMatch;
  });

  return (
    <div className="p-6">
      <NoticeComponent title="상품상태" content="" />

      {/* 상태 버튼 그룹 */}
      <div className="flex items-center mt-4">
        <div className="flex gap-3 justify-center w-full">
          {statuses.map((status) => (
            <button
              key={status.name}
              className={`border border-gray-100 shadow font-light px-5 py-2 text-[15px] rounded-full transition duration-200 flex items-center gap-2 ${
                selectedStatus === status.name
                  ? 'bg-black/75 text-white'
                  : 'bg-gray-100 text-gray-700'
              }`}
              onClick={() => setSelectedStatus(status.name)}
              aria-pressed={selectedStatus === status.name}
            >
              {status.icon}
              <span>{status.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* 카테고리 버튼 그룹 및 상품 등록 버튼 */}
      <div className="flex items-center justify-between mt-6">
        <div>
          <div className="flex gap-2">
            {categories.map((category) => (
              <button
                key={category.name}
                className={`font-normal border bg-white border-gray-100 shadow px-4 py-2 text-md rounded-full transition duration-200 ${
                  selectedCategory === category.name
                    ? 'border-black/75 text-[#111]'
                    : 'text-gray-400'
                }`}
                onClick={() => setSelectedCategory(category.name)}
                aria-pressed={selectedCategory === category.name}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
        <div>
          <button
            className="hover:text-blue-500 flex items-center gap-2 text-nowrap transition duration-300 ease-in-out text-[#555] py-2 px-4 font-medium text-sm"
            onClick={openModal}
          >
            <FaPlus /> 상품등록
          </button>
        </div>
      </div>

      {/* 상품 등록 모달 */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <AddProduct closeModal={closeModal} onAddProduct={handleAddProduct} />
      </Modal>

      {/* StatusPage 컴포넌트 */}
      <div className="mt-6">
        <div className="border shadow-md w-full min-h-[650px] h-full rounded-lg px-4 pt-1">
          <StatusPage status={selectedStatus} products={filteredProducts} />
        </div>
      </div>
    </div>
  );
}
